import React from 'react'

export default function footer() {
    const year = new Date().getFullYear();
    return (
        <footer className='footer pb-3'>
            <h3 style={{color: '#fff', textAlign: 'center'}}>GoFood Developed By Gajendra ⓒ {year}</h3>
        </footer>
    );
}
